import { usePersonalizedContent } from './usePersonalizedContent';
export const usePersonalizedTitle = () => {
  var _data$title;
  const {
    data,
    isEnabled,
    isLoading
  } = usePersonalizedContent();
  return {
    translation: isEnabled ? data == null || (_data$title = data.title) == null ? void 0 : _data$title.translation : undefined,
    isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedTitle.js.map